import styled, { css } from 'styled-components';

import resets from '../../../assets/styled/resets';
import { colorTokens, fontTokens } from '../../../tokens/globals/tokens';

const CoreVerticalNavElement = styled.div`
  ${resets.BrowserAnchor}
  ${resets.BrowserButton}
  border-radius: 3px;
  color: ${colorTokens.GlobalBrandGray70};
  cursor: pointer;
  font-weight: ${fontTokens.GlobalWeightBody2};
  margin: 0 0 6px 1px;
  padding: 6px 8px;

  &:hover,
  &:focus {
    background-color: ${colorTokens.GlobalBrandGray20};
    box-shadow: none;
    color: ${colorTokens.GlobalBrandBlack};
  }

  ${({ theme }) =>
    theme.active &&
    css`
      background-color: ${colorTokens.GlobalBrandGray20};
      box-shadow: none;
      color: ${colorTokens.GlobalBrandBlack};

      &:focus {
        background-color: ${colorTokens.GlobalBrandGray30};
      }
    `}

  ${({ theme }) =>
    theme.whiteSpace === 'nowrap' &&
    css`
      text-overflow: ellipsis;
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
    `}
`;

export { CoreVerticalNavElement };
